"use client";

import { Link } from "@/components/common/Link";
import { Mail, Phone, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactUsSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="skontaktuj-się-z-nami" ref={ref} className={`py-16 lg:py-24 bg-background text-foreground transition-opacity duration-[var(--duration-medium)] ${isVisible ? "opacity-100 animate-reveal" : "opacity-0"}`}>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl md:text-5xl font-display font-semibold mb-6 tracking-tight text-center">
                Skontaktuj się z nami
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed mb-8 text-center">
                Jeżeli doznałeś szkody osobowej, brałeś udział w wypadku lub potrzebujesz oceny swojej sytuacji prawnej, skontaktuj się w celu analizy sprawy. Oferujemy profesjonalną pomoc prawną dla osób poszkodowanych.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="bg-primary/10 p-3 rounded-md mt-1">
                  <MapPin className="size-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-display font-semibold text-lg mb-1">Adres</h3>
                  <p className="text-muted-foreground">ul. Adama Mickiewicza 57<br />76-200 Słupsk</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-primary/10 p-3 rounded-md mt-1">
                  <Phone className="size-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-display font-semibold text-lg mb-1">Telefon</h3>
                  <Link to="tel:504144406" className="text-muted-foreground hover:text-primary transition-colors duration-150">
                    504 144 406
                  </Link>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-primary/10 p-3 rounded-md mt-1">
                  <Mail className="size-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-display font-semibold text-lg mb-1">Email</h3>
                  <Link to="mailto:b.parchomiuk@trasta.pl" className="text-muted-foreground hover:text-primary transition-colors duration-150">
                    b.parchomiuk@trasta.pl
                  </Link>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-border">
              <p className="text-lg text-foreground leading-relaxed text-center font-serif">
                Jeżeli doznałeś szkody osobowej, brałeś udział w wypadku lub potrzebujesz oceny swojej sytuacji prawnej, skontaktuj się w celu analizy sprawy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}